// @ts-nocheck
import { motion } from 'framer-motion'

export function SuggestionChips({ suggestions, onClick }) {
  if (!suggestions || suggestions.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2 mt-2" data-testid="suggestion-chips">
      {suggestions.map((s, i) => (
        <motion.button
          key={s}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: i * 0.06 }}
          onClick={() => onClick?.(s)}
          data-testid={`suggestion-chip-${i}`}
          className="text-xs border border-border/50 bg-card text-muted-foreground hover:text-foreground hover:bg-accent/50 px-3 py-1.5 rounded-full transition-colors duration-150 cursor-pointer"
        >
          {s}
        </motion.button>
      ))}
    </div>
  )
}
